import { render, staticRenderFns } from "./pt-legend.vue?vue&type=template&id=7f8f4160&"
import script from "./pt-legend.vue?vue&type=script&lang=js&"
export * from "./pt-legend.vue?vue&type=script&lang=js&"
import style0 from "./pt-legend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports